// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wGavxeNG8t7ZR4PNuusS{align-items:flex-end;display:flex;flex-grow:1;font-size:16px;justify-content:space-evenly;max-height:28px;width:100%}.G19CUmjOKMYo3zdGV7L_.G19CUmjOKMYo3zdGV7L_.G19CUmjOKMYo3zdGV7L_{font-weight:500;line-height:28px;margin-bottom:0;min-width:45px;text-align:center;text-transform:uppercase}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `wGavxeNG8t7ZR4PNuusS`,
	"clockLabel": `G19CUmjOKMYo3zdGV7L_`
};
export default ___CSS_LOADER_EXPORT___;
